// components/TestRunner/rules/Rule06c_SOR_NamingStandard_HorsService.js
import { Rule06_SOR_NamingStandard_Shared } from "./Rule06_SOR_NamingStandard_Shared.js";

/**
 * Rule06c_SOR_NamingStandard_OutOfService.js
 *
 * ✅ Règle 06c — Les fichiers SOR de fibres hors service doivent respecter le standard de nommage technique
 * Type: Error
 *
 * 🧪 Tests effectués :
 * • Contrôle RuleUtils.parseSorFileName() pour extraction des éléments
 * • Validation extension .sor et séparateur _OE_
 * • Validation préfixe contre fiber.ropRef.PBO_VALUE avec conversion de format
 * • Validation position B2-T[X]-M[Y]-[ZZZ]
 * • Validation longueur d'onde 1310nm ou 1550nm
 * • Validation numéro de tentative optionnel -[chiffre] ou _[chiffre]
 */

export class Rule06c_SOR_NamingStandard_HorsService {
  /**
   * Appliquer la règle 06c : Standard de nommage SOR pour hors service
   * @param {Object} fiber - Objet fibre avec toutes ses données
   */
  static apply(fiber) {
    // Prérequis : Rule00 + Rule01 + Rule03 ont validé l'existence des données de base
    // Vérifier qu'on est dans un cas de PV hors service
    if (!fiber.hasPvHs) {
      return; // Règle ne s'applique qu'aux fibres avec PV réussite
    }

    // Déléguer la validation à la classe partagée avec le préfixe SRO-BPI
    const errorMessages = Rule06_SOR_NamingStandard_Shared.validateFiles(fiber.pvHs.files, fiber, "R06c");

    // Ajouter les erreurs au résultat de la fibre
    errorMessages.forEach((errorMessage) => {
      this._addError(fiber, errorMessage.rule, errorMessage.title, errorMessage.message);
    });
  }

  /**
   * Analyser tous les fichiers .sor
   */
  static _addError(fiber, rule, title, message) {
    if (!fiber.testResults) {
      fiber.testResults = {
        status: "success",
        hasError: false,
        messages: [],
      };
    }

    fiber.testResults.status = "error";
    fiber.testResults.hasError = true;
    fiber.testResults.messages.push({
      type: "error",
      rule,
      title,
      message,
    });
  }
}
